// for global reducer

export const SET_LOADING = "SET_LOADING";
export const SET_ACCOUNT_DETAILS = "SET_ACCOUNT_DETAILS";
export const SET_HAS_METAMASK = "SET_HAS_METAMASK";
export const SET_ERROR = "SET_ERROR";
export const SET_CHAIN_ID = "SET_CHAIN_ID";
export const SET_ETHER_CUR_AMOUNT = "SET_ETHER_CUR_AMOUNT";
export const SHOW_WARNING = "SHOW_WARNING";
export const HIDE_WARNING = "HIDE_WARNING";
export const SET_WEB3_INSTANCE = "SET_WEB3_INSTANCE";
export const UPDATE_PROVIDER = "UPDATE_PROVIDER";
export const SHOW_WALLET_MODAL = "SHOW_WALLET_MODAL";
export const HIDE_WALLET_MODAL = "HIDE_WALLET_MODAL";
export const TOGGLE_WALLET_MODAL = "TOGGLE_WALLET_MODAL";
export const SHOW_SEND_SIGN_MSG_MODAL = "SHOW_SEND_SIGN_MSG_MODAL";
export const HIDE_SEND_SIGN_MSG_MODAL = "HIDE_SEND_SIGN_MSG_MODAL";
export const SET_APPROVED = "SET_APPROVED";
export const SET_REALTIME_VALUES = "SET_REALTIME_VALUE";
export const SET_NETWORK = "SET_NETWORK";
export const SET_WEB3 = "SET_WEB3";
export const SET_POOL_FACTORY = "SET_POOL_FACTORY";
export const SET_CORE_POOL = "SET_CORE_POOL";
export const SET_CORE_POOL_ADDRESS = "SET_CORE_POOL_ADDRESS";
export const SET_POOL_ADDRESSES = "SET_POOL_ADDRESSES";
export const SET_POOL_CONTRACTS = "SET_POOL_CONTRACTS";
export const SET_TOKEN_SYMBOL = "SET_TOKEN_SYMBOL";
export const SET_NETWORKID_FROM_URL = "SET_NETWORKID_FROM_URL";
export const SET_DATA_FROM_POOL = "SET_DATA_FROM_POOL";
export const SET_REWARD_DECIMAL_POOL_TOKEN_DECIMAL =
  "SET_REWARD_DECIMAL_POOL_TOKEN_DECIMAL";
export const SET_POOL_DETAILS_FROM_FACTORY = "SET_POOL_DETAILS_FROM_FACTORY";
export const SET_ACTION_BASED_DATA = "SET_ACTION_BASED_DATA"
export const SET_FIRST_LOAD_DATA = "SET_FIRST_LOAD_DATA"
export const SET_SECOND_LOAD_DATA = "SET_SECOND_LOAD_DATA"
// for login reducer

export const UPDATE_LOGIN = "UPDATE_LOGIN";
export const UPDATE_MSG = "UPDATE_MSG";
export const SET_LOGIN_LOADING = "SET_LOGIN_LOADING";
export const SET_REQUEST_STATUS = "SET_REQUEST_STATUS";

// for user reducer

export const SET_USER = "SET_USER";
export const UPDATE_PROFILE_IMG = "UPDATE_PROFILE_IMG";
export const UPDATE_USER_DATA = "UPDATE_USER_DATA";
export const SET_IMG_LOADING = "SET_IMG_LOADING";

// for  contract reducere

export const SET_CONTRACT = "SET_CONTRACT";
export const SET_CONTRACT_INFO = "SET_CONTRACT_INFO";
export const SET_CONTRACT_ABI = "SET_CONTRACT_ABI";
export const INIT_CONTRACT = "INIT_CONTRACT";
export const SET_CHAIN_INFO = "SET_CHAIN_INFO";
export const SET_CHAIN_INFO_LOADING = "SET_CHAIN_INFO_LOADING";
